<template>
  <div class="SceneButtonWidget lxn-w100 lxn-h100" :class="disabledClass">
    <div style="height: 5px;" class="lxn-w100">
    </div>
    <div @click="runScene" class="SceneButtonWidget-wrapper-d1 lxn-margin-auto lxn-circle lxn-pos-rel lxn-cursor-pointer">
      <div class="SceneButtonWidget-wrapper-led lxn-pos-abs lxn-circle" :style="activeStyle">
      </div>
      <div class="SceneButtonWidget-wrapper-d2 lxn-circle lxn-w100 lxn-h100 lxn-text lxn-text-center" :class="[$store.getters.language.font]" :style="circleBorderColor">
        {{$store.getters.language.texts.SceneButton_runScene}}
      </div>
    </div>
  </div>
</template>

<script>
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'SceneButtonWidget',
  props: {
    index: Number
  },
  components: {
  },
  data: function () {
    return {
      switchLocked: false,
      isButtonActive: false,
    }
  },
  mounted: function () {
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[3];
      }
    },
    isHubOffline: function () {
      var isHubOffline = false;
      if(this.index != -1){
        for(var i = 0; i < this.widget.settings.commands.length; i++){
          var hub = this.$store.getters.getHubByUUID(this.widget.settings.commands[i].hubUUID);
          if(hub.connectionStatus.local != 2 && hub.connectionStatus.online != 2){
            isHubOffline = true;
          }
        }
      }
      return isHubOffline;
    },
    disabledClass: function () {
      if(this.index != -1){
        if(this.isHubOffline){
          return "disabled";
        }else{
          return "";
        }
      }else{
        return "";
      }
    },
    circleBorderColor: function () {
      return "border-color: " + this.widgetColor + ";";
    },
    activeStyle: function () {
      if(this.isButtonActive){
        return "background-color: " + this.widgetColor + ";";
      }else{
        return "";
      }
    },
  },
  methods: {
    generateNodeActions: function (nodeActions) {
      var generatedNodeActions = [];
      var typeOfAction = 0;
      var valueOfChange = 0;

      for(var i = 0; i < nodeActions.length; i++){
        var isNodeNew = true;
        if(nodeActions[i].outputType != "IrDevice" && nodeActions[i].outputType != "RfDevice"){
          if(nodeActions[i].state == 'on'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 1;
          }else if(nodeActions[i].state == 'off'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 0;
          }
        }else if(nodeActions[i].outputType == "IrDevice"){
          var deviceType = nodeActions[i].outputSettings.deviceType;
          var brand = nodeActions[i].outputSettings.brand;
          var model = nodeActions[i].outputSettings.model;
          var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

          valueOfChange = messaging.utility.arrayTo128(irDevice.commands[nodeActions[i].state.targetCommandIndex].command);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }else if(nodeActions[i].outputType == "RfDevice"){
          valueOfChange = messaging.utility.arrayTo128(nodeActions[i].state.rfCommand);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }
        var action = {
          parameterId: nodeActions[i].parameterId,
          valueOfChange: valueOfChange,
          typeOfAction: typeOfAction,
          timeDelay: nodeActions[i].timeDelay,
        }

        for(var j = 0; j < generatedNodeActions.length; j++){
          if(generatedNodeActions[j].nodeUUID == nodeActions[i].nodeUUID){
            generatedNodeActions[j].actions.push(action);
            isNodeNew = false;
            break;
          }
        }
        if(isNodeNew){
          generatedNodeActions.push(
            {
              nodeUUID: nodeActions[i].nodeUUID,
              actions: [action]
            }
          );
        }
      }
      return generatedNodeActions;
    },
    calculateCommandLength: function (nodeActions, hub) {
      var commandToSend = [];
      var messagingHook = new Messaging(new Logger(false));
      var psk = hub.psk;
      var destinationUUID = hub.uuid;

      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });

      messagingHook.setParametersOfNodesSerializer(commandToSend, {nodeActions: nodeActions});
      return commandToSend.length;
    },
    sendCommand (nodeActions, hub) {
      return new Promise( (resolve) => {
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            nodeActions: nodeActions,
          }
        })
        .then( () => {
          resolve();
        })
        .catch( response => {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
          //TODO: should I reject?!
          // reject(hub.UUID);
          resolve();
        });
      })
    },
    delay (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    async runScene() {
      if(this.index != -1){
        if(!this.switchLocked){
          this.$store.commit('setAppBusy', true);
          this.switchLocked = true;
          this.isButtonActive = true;

          console.log('running scene');
          for(var i = 0; i < this.widget.settings.commands.length; i++){
            var hub = this.$store.getters.getHubByUUID(this.widget.settings.commands[i].hubUUID);
            this.$store.commit('setHubStatus', {
              hubIndex: hub.index,
              stateUpdateEnabled: false,
            });
            var commandPool = this.widget.settings.commands[i].actions.slice();
            var nodeActions = [];

            do {
              nodeActions.push(commandPool.shift());
              var generatedNodeActions = this.generateNodeActions(nodeActions);
              var commandLength = this.calculateCommandLength(generatedNodeActions, hub);
              if(commandLength > CONFIGS.MAX_LORA_PACKET_SIZE){
                commandPool.unshift(nodeActions.pop());
                generatedNodeActions = this.generateNodeActions(nodeActions);
                await this.sendCommand(generatedNodeActions, hub);
                nodeActions = [];
                // console.log("sent the big command");
              }
              if(commandPool.length == 0){
                generatedNodeActions = this.generateNodeActions(nodeActions);
                // console.log("sending smaller packet");
                await this.sendCommand(generatedNodeActions, hub);
                // console.log("sent smaller packet");
              }
            }
            while(commandPool.length != 0);
            this.$store.commit('setHubStatus', {
              hubIndex: hub.index,
              stateUpdateEnabled: true,
            });
          }
          console.log("DONE!!!");
          this.switchLocked = false;
          this.isButtonActive = false;
          this.$store.commit('setAppBusy', false);
        }
      }
    },
  },
}
</script>

<style>
  .SceneButtonWidget.disabled {
    opacity: 0.5;
  }
  .SceneButtonWidget-wrapper-d1 {
    width: 60px;
    height: 60px;
    background-color: #ECECEC;
    box-sizing: border-box;
    border-width: 5px;
    border-style: solid;
    border-color: #DEDEDE;
  }
  .SceneButtonWidget-wrapper-d2 {
    background-color: #ECECEC;
    box-sizing: border-box;
    border-width: 3px;
    border-style: solid;
    line-height: 55px;
  }
  .SceneButtonWidget-wrapper-led {
    left: calc(50% - 5px);
    top: 10px;
    width: 10px;
    height: 5px;
    background-color: #8A9DA8;
  }
</style>
